import { render, staticRenderFns } from "./CellSwitch.vue?vue&type=template&id=0c6b70e5&scoped=true&"
import script from "./CellSwitch.vue?vue&type=script&lang=ts&"
export * from "./CellSwitch.vue?vue&type=script&lang=ts&"
import style0 from "./CellSwitch.vue?vue&type=style&index=0&id=0c6b70e5&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.9.0@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c6b70e5",
  null
  
)

export default component.exports